const marketplaceSection = "/marketplace/";

export const marketplaceUrl = marketplaceSection;
